module.exports = __webpack_public_path__ + "assets/images/Matemágico_1c3958d4664da305228a6c9fff1b48f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mapa-das-ilhas/dialogos/Matemágico.png
// module id = 140
// module chunks = 0